import { Button } from '@components/button';
import { IconModeDark } from '@components/icons/icon-mode-dark';
import { IconModeLight } from '@components/icons/icon-mode-light';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useCurrentTheme } from '@components/theme-provider';
import { ToggleGroup } from '@components/toggle-group';
import { useScopedTranslate } from '@locale/translate';

import { useInvalidateAuthentication } from 'api/authentication/hooks';
import { useEditPreboarding } from 'api/preboarding/hooks';
import { Title } from 'ui/unauthenticated/pages/common';

import { ContentContainer, PreboardingStepper, PreboardingPageContainer } from './common';

const SelectTheme = () => {
  const { t } = useScopedTranslate(locale);
  const { currentTheme, setTheme } = useCurrentTheme();
  const { invalidateCurrentUser } = useInvalidateAuthentication();
  const editMutation = useEditPreboarding({ onSuccess: invalidateCurrentUser });

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append('hasFinishedPreboarding', 'true');
    return editMutation.mutate(formData);
  };

  return (
    <ContentContainer>
      <Stack space={2} align="center">
        <Title>{t('title')}</Title>
        <Text text={t('description')} />
      </Stack>
      <Stack space={6} orientation="horizontal" align="center">
        <Text font="semibold14" text={t('lightMode')} />
        <ToggleGroup.Root defaultValue={currentTheme} onChange={setTheme}>
          <ToggleGroup.IconButton icon={IconModeLight} value="light" />
          <ToggleGroup.IconButton icon={IconModeDark} value="dark" />
        </ToggleGroup.Root>
        <Text font="semibold14" text={t('darkMode')} />
      </Stack>
      <Button
        font="semibold14"
        text={t('continue')}
        onClick={handleSubmit}
        variant="primary-blue"
        style={{ width: '100%' }}
      />
      <PreboardingStepper currentIndex={2} />
    </ContentContainer>
  );
};

export const SetThemePage = () => {
  return (
    <PreboardingPageContainer>
      <SelectTheme />
    </PreboardingPageContainer>
  );
};

const locale = {
  en: {
    title: 'Last but not least',
    description: 'Are you on the light (Jedi) or dark (Sith) side?',
    lightMode: 'Light mode',
    darkMode: 'Dark mode',
    continue: 'Go to Journeys',
  },
};
